import type { CompanyBlock } from '@/model/Company'

export function isCompanyAccessBlocked(block?: CompanyBlock): boolean {
  if (!block?.blocked || !block.date) {
    return false
  }
  return Date.now() >= new Date(block.date).getTime()
}
